import { __decorate } from "tslib";
import { injectable } from "inversify";
import { raise } from "@leavy/utils";
import { map } from "rxjs/operators";
import { MutableStore } from "../../store";
import { normalizeI18nKey } from "../util";
let TranslationStore = class TranslationStore extends MutableStore {
    getByKey(key) {
        const normalizedKey = normalizeI18nKey(key);
        return this.value.translations.get(normalizedKey);
    }
    getByKeyOrThrow(key) {
        const normalizedKey = normalizeI18nKey(key);
        return this.getByKey(normalizedKey) ?? raise(new Error(`Translation not found for key: ${normalizedKey}`));
    }
    getByKey$(key) {
        const normalizedKey = normalizeI18nKey(key);
        return this.value$
            .pipe(map(state => state.translations.get(normalizedKey)));
    }
    getAll() {
        return this.value.translations;
    }
    getAll$() {
        return this.value$
            .pipe(map(state => state.translations));
    }
};
TranslationStore = __decorate([
    injectable()
], TranslationStore);
export { TranslationStore };
//# sourceMappingURL=TranslationStore.js.map